import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import LabPatientInformation from './LabPatientInformation';
import LabPatientOperation from './LabPatientOperation';
const LabPatientCards = ({
  content,
  setOpenOperation,
  openOperation,
}) => {
  const [forceRender, setForceRender] = useState(false);

  const [lab_open, setlab_open] = useState(() =>
    JSON.parse(sessionStorage.getItem('lab'))
  );

  useEffect(() => {
    setlab_open(sessionStorage.getItem('lab'));
  }, [JSON.parse(sessionStorage.getItem('lab'))]);

  return (
    <React.Fragment>
      <Stack
        padding=".3em"
        borderRadius={'20px'}
        sx={{
          backgroundColor: content.FldConferm
            ? 'lightgreen'
            : 'white',
        }}
      >
        <LabPatientInformation
          content={content}
          setOpenOperation={setOpenOperation}
          openOperation={openOperation}
        />
        {forceRender ? <></> : <></>}
        {openOperation?.includes(content?.FldId) ||
        lab_open?.includes(content?.FldId) ? (
          <LabPatientOperation
            content={content}
            setForceRender={setForceRender}
          />
        ) : (
          <></>
        )}
      </Stack>
    </React.Fragment>
  );
};

export default LabPatientCards;
